/**
 * Easy Estimate funnel (Jennifer flow). Edit labels here.
 */
export const PROJECT_TYPE_KEYS = ["home_repair", "remodel"];

export const PROJECT_TYPES = {
  home_repair: {
    label: "Home Repair",
    emoji: "🏠",
    timingHeader: "When Would You Like to Get it Fixed?",
  },
  remodel: {
    label: "Remodel / Upgrade",
    emoji: "🔨",
    timingHeader: "When Would You Like Get Started?",
  },
};

export const TIMING_NOW = "I need help NOW";
export const TIMING_LATER = "Remind me Later";
